var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-body',{ref:"messages",staticClass:"mt-1 height-500 overflow-y-scroll messages-body"},_vm._l((_vm.dataItem.messages),function(message,key){return _c('message-item',{key:key,attrs:{"item-data":message}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }